<script>
    import {addDays, format, isBefore, isSameDay, isValid, setHours, parseISO} from 'date-fns';

    export let periodFrom;
    export let periodTo;

    const from = parseISO(periodFrom);
    const to = parseISO(periodTo);

    let fromFormat = 'EEEE dd LLLL yyyy kk:mm';
    let toFormat = 'EEEE dd LLLL yyyy kk:mm';

    const goodMorning = setHours(addDays(from, 1), 9);
    if(isSameDay(from, to) || (isSameDay(goodMorning, to) && isBefore(to, goodMorning) )) {
      toFormat = 'kk:mm';
    }

    const fromFormatted = isValid(from) ? format(from, fromFormat) : '';
    const toFormatted = isValid(to) ? format(to, toFormat) : '';
</script>

{ fromFormatted } - {toFormatted}